import React, { useRef } from 'react';
import clsx from 'clsx';
import styles from './style.module.css';
import BoxButton from '../../BoxButton/BoxButton';
import loader from '../../../images/loader.gif';

const BoxClassroom = ({ properties, showTeacher, selected }) => {
  const node = useRef();

  const showUndoLink = properties.attributes.showUndoLink
    || (properties.attributes.assigned_photos_count !== null
      && properties.attributes.assigned_photos_count > 0);
  const processed = properties.attributes.event_processed_at !== null;

  const isNodeDefined = n => n.current !== undefined && n.current !== null;

  const showTeacherConditionally = (e) => {
    if (isNodeDefined(node) && node.current.contains(e.target)) {
      return;
    }

    showTeacher(properties.id);
  };

  return (
    <div
      className={clsx(styles.boxClassroom, 'box', selected && styles.selected)}
      id={properties.id}
      onClick={e => showTeacherConditionally(e)}
    >
      <div className={styles.boxClassroomproperties}>
        {showUndoLink && (
          <span className="undo" onClick={() => properties.undoUpdate(properties.id)}>
            undo photos assignment
          </span>
        )}
        {properties.isLoadingAssignment && properties.id === properties.boxOfAssignment && (
          <img src={loader} alt="" className="loader" />
        )}
        <div className={styles.details}>
          <strong className={styles[properties.attributes.name]}>
            {properties.attributes.name}
          </strong>
          <strong className={styles[properties.attributes.classYear]}>
            {properties.attributes.classYear}
          </strong>
          <p className={styles.name}>
            {properties.attributes.teacher_first_name}
            <br />
            {properties.attributes.teacher_last_name}
          </p>
          <p className={styles.memberCount}>
            {properties.attributes.members_count}
            {' '}
            zugeordnete Schüler
          </p>
        </div>
      </div>
      <BoxButton
        icon="fas fa-check fa-lg"
        handleClick={() => properties.handleClick(properties.id)}
        processed={processed}
        node={node}
      />
    </div>
  );
};

export default BoxClassroom;



// WEBPACK FOOTER //
// ./src/components/ContentBox/BoxClassroom/BoxClassroom.js